module.exports = __webpack_public_path__ + "img/pdf_2.20daa0ff.png";